class CountdownTextTimer extends HTMLElement {
  connectedCallback() {
    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  update() {
    var expiration = parseInt(this.dataset.expiration, 10) * 1000;
    var remaining = expiration - Date.now();

    if (remaining <= 0) {
      if (!this.querySelector('[data-countdown-text-ended]')) {
        this.innerHTML = '<span class="countdown-text__ended" data-countdown-text-ended>Offer has ended</span>';
      }
      clearInterval(this.interval);
      return;
    }

    var days = Math.floor(remaining / 86400000);
    var hours = Math.floor((remaining % 86400000) / 3600000);
    var minutes = Math.floor((remaining % 3600000) / 60000);
    var seconds = Math.floor((remaining % 60000) / 1000);

    var pad = function (value) {
      return value < 10 ? '0' + value : String(value);
    };

    var daysEl = this.querySelector('[data-days]');
    var hoursEl = this.querySelector('[data-hours]');
    var minutesEl = this.querySelector('[data-minutes]');
    var secondsEl = this.querySelector('[data-seconds]');

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);
  }
}

customElements.define('countdown-text-timer', CountdownTextTimer);
